exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-menu__item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin-bottom:.5rem}.c-menu__item__link{padding:.35rem;margin:0 -.35rem;display:block}.c-menu__item__link.is-active,.c-menu__item__link:hover{background-color:tomato;color:#fff}", ""]);

// exports
